import React from 'react';
var MAX_PAGES = 10;
var RubriqPaginator = function RubriqPaginator(_ref) {
  var totalCount = _ref.totalCount,
    currentPage = _ref.currentPage,
    pageSize = _ref.pageSize,
    onPageChange = _ref.onPageChange,
    className = _ref.className;
  var pages = Math.ceil(totalCount / pageSize);
  var hasNext = currentPage + 1 <= pages;
  var hasPrev = currentPage - 1 > 0;
  var getPageRange = function getPageRange(currentPage, pages) {
    if (!pages) {
      return [];
    }
    var length = pages <= MAX_PAGES ? pages : MAX_PAGES;
    var start = currentPage - Math.floor(length / 2);
    start = Math.max(start, 1);
    start = Math.min(start, 1 + pages - length);
    return Array.from({
      length: length
    }, function (_, i) {
      return start + i;
    });
  };
  var changePage = function changePage(page) {
    onPageChange(page);

    // make sure user starts from the top of the list of page items when changing page
    window.scrollTo(0, 0);
  };
  if (pages <= 1) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "pagination-wrapper ".concat(className)
  }, /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("ul", {
    className: "pagination"
  }, /*#__PURE__*/React.createElement("li", {
    className: "".concat(hasPrev ? 'page-item' : 'page-item disabled')
  }, hasPrev ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "skip-tracking page-link",
    onClick: function onClick() {
      return changePage(currentPage - 1);
    }
  }, "\xAB") : /*#__PURE__*/React.createElement("span", {
    className: "page-link"
  }, "\xAB")), getPageRange(currentPage, pages).map(function (page) {
    return /*#__PURE__*/React.createElement("li", {
      key: page,
      className: "".concat(page !== currentPage ? 'page-item' : 'page-item disabled active')
    }, page !== currentPage ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "skip-tracking page-link",
      onClick: function onClick() {
        return changePage(page);
      }
    }, page) : /*#__PURE__*/React.createElement("span", {
      className: "page-link"
    }, page));
  }), /*#__PURE__*/React.createElement("li", {
    className: "".concat(hasNext ? 'page-item' : 'page-item disabled')
  }, hasNext ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "skip-tracking page-link",
    onClick: function onClick() {
      return changePage(currentPage + 1);
    }
  }, "\xBB") : /*#__PURE__*/React.createElement("span", {
    className: "page-link"
  }, "\xBB")))));
};
export default RubriqPaginator;